import React, { memo, useState } from 'react'
import { Modal } from 'components/Modals/Modal'
import { LoginForm } from '../LoginForm'
import { SignUpForm } from '../SignUpForm'
import { ForgotPasswordForm } from '../ForgotPasswordForm'
import { Bubble } from 'components/Bubble'
import { Wrapper } from 'styles/styleSystem/wrapper'
import { PropType } from 'helpers/types/PropType'

const SECTIONS = [
  { name: 'login', modalTitle: 'Login to Fintros' },
  { name: 'signup', modalTitle: 'Join Fintros' },
  { name: 'forgotPassword', modalTitle: 'Forgot Password' },
]

interface AutModalInterface {
  isOpen: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  message?: string
}

export const AuthModal: React.FC<AutModalInterface> = memo(
  ({ isOpen, setOpen, message }) => {
    const [section, setSection] = useState(SECTIONS[0])

    const handleSectionChange = (name) => {
      setSection(SECTIONS.find((s) => s.name === name))
    }

    return (
      <Modal
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        title={section.modalTitle}
        maxWidth="500px"
        noFooter
      >
        {message && (
          <Wrapper mb={20}>
            <Bubble text={message} type="warning" />
          </Wrapper>
        )}
        <ModalLoginForm
          handleSectionChange={handleSectionChange}
          sectionName={section.name}
        />
      </Modal>
    )
  }
)

const ModalLoginForm: React.FC<{
  sectionName: string
  handleSectionChange: (name: any) => void
}> = memo(({ sectionName, handleSectionChange }) => {
  switch (sectionName) {
    case 'login':
      return (
        <LoginForm
          setSection={(name) => handleSectionChange(name)}
          isAuthModal
        />
      )
    case 'signup':
      return <SignUpForm setSection={(name) => handleSectionChange(name)} />
    case 'forgotPassword':
      return (
        <ForgotPasswordForm setSection={(name) => handleSectionChange(name)} />
      )
  }
})
